﻿import React from 'react';
import {MenuItem} from "@mui/material";
import {SortDirType} from "../../../types/common/SortDirType";
import {SupplierInventorySortByType} from "../../../types/supplier/SupplierInventorySortByType";
import SortSelect from "../../common/inputs/sortSelect/SortSelect";

type SupplierCurrentInventorySortSelectProps = {
  sortBy: SupplierInventorySortByType;
  onSortByChange: (value: SupplierInventorySortByType) => void;
  sortDir: SortDirType;
  onSortDirChange: (value: SortDirType) => void;
}

const SupplierCurrentInventorySortSelect = ({ sortBy, sortDir, onSortDirChange, onSortByChange }: SupplierCurrentInventorySortSelectProps) => {

  return <SortSelect<SupplierInventorySortByType> sortBy={sortBy}
                                                  onSortByChange={onSortByChange}
                                                  sortDir={sortDir}
                                                  onSortDirChange={onSortDirChange}
                                                  label={'Sort By'}
  >
    <MenuItem value={'CHECK_IN_DATE'}>Check In Date</MenuItem>
    <MenuItem value={'LOCATION_NAME'}>Location Name</MenuItem>
    <MenuItem value={'BUYER_NAME'}>Buyer Name</MenuItem>
    <MenuItem value={'ASSET_TYPE'}>Asset Type</MenuItem>
    <MenuItem value={'ORDER_NUMBER'}>Order Number</MenuItem>
    <MenuItem value={'DRIVER_FIRST_NAME'}>Driver First Name</MenuItem>
    <MenuItem value={'DRIVER_LAST_NAME'}>Driver Last Name</MenuItem>
    <MenuItem value={'CONTAINER_NUMBER'}>Container Number</MenuItem>
    <MenuItem value={'TRAILER_NUMBER'}>Trailer Number</MenuItem>
    <MenuItem value={'CHASSIS_NUMBER'}>Chassis Number</MenuItem>
    <MenuItem value={'TRUCK_LICENSE_PLATE_NUMBER'}>Truck License Plate Number</MenuItem>
  </SortSelect>
}

export { SupplierCurrentInventorySortSelect };
